import React, { useState } from "react";
import { ShieldCheck, Loader2, User as UserIcon, Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { username, password });
      setUser(res.data);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login gagal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b1220] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: "radial-gradient(circle at 20% 30%, #38bdf8 0, transparent 40%), radial-gradient(circle at 80% 70%, #f59e0b 0, transparent 40%)" }} />
      <div className="relative bg-white rounded-2xl shadow-2xl p-10 w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-xl bg-[#0b1220] flex items-center justify-center mx-auto mb-5">
            <ShieldCheck className="w-9 h-9 text-amber-400" />
          </div>
          <h1 className="text-2xl font-extrabold text-slate-900">HSE Report</h1>
          <p className="text-slate-500 mb-1 font-medium">PT. Ithikhara</p>
          <p className="text-sm text-slate-400">Safety Monitoring System</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs text-slate-600">Username</Label>
            <div className="relative mt-1">
              <UserIcon className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <Input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Masukkan username" className="pl-9" data-testid="login-username" autoComplete="username" />
            </div>
          </div>
          <div>
            <Label className="text-xs text-slate-600">Password</Label>
            <div className="relative mt-1">
              <Lock className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Masukkan password" className="pl-9" data-testid="login-password" autoComplete="current-password" />
            </div>
          </div>
          {error && <p className="text-sm text-red-500 bg-red-50 rounded-lg px-3 py-2" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full bg-[#0b1220] hover:bg-slate-800 h-11" data-testid="login-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Masuk"}
          </Button>
        </form>
      </div>
    </div>
  );
}
